const MSONRY_GRID_CLASS = '.masonry-grid';
const MSONRY_GRID_ITEM_CLASS = '.masonry-grid-item';
const MSONRY_GUTTER_SIZER_CLASS = '.masonry-gutter-sizer';

import Masonry from 'masonry-layout';

export default class MasonryUtils {
    constructor(elm) {
        this.elm = elm;
        if (elm) {
            this.initMasonry();
        }
    }

    initMasonry() {
        if (!this.msonryObj) {
            this.msonryObj = new Masonry(MSONRY_GRID_CLASS, {
                itemSelector: MSONRY_GRID_ITEM_CLASS,
                columnWidth: MSONRY_GRID_ITEM_CLASS,
                gutter: MSONRY_GUTTER_SIZER_CLASS,
                transitionDuration: '0s',
                percentPosition: true,
            });
        }
        return this.msonryObj;
    }

    getMasonObj() {
        return this.msonryObj ?? this.initMasonry();
    }

    printItems() {
        console.log(this.getMasonObj().getItemElements());
    }

    reset() {
        this.getMasonObj().destroy();
        this.msonryObj = null;
    }

    appendNodes(elmNodes) {
        this.getMasonObj().appended(elmNodes);
    }

    layout() {
        this.getMasonObj().layout();
    }

    reloadLayout() {
        const msonryObj = this.getMasonObj();
        msonryObj.reloadItems();
        msonryObj.layout();
    }
}
